var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('wrapper',[_c('el-popover',{attrs:{"width":"230","placeholder":"bottom"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }